import { v4 as uuidv4 } from 'uuid';

export function getIdempotencyKey(): string {
  return uuidv4();
}
